import React, { useEffect, useState } from "react";
import Select from "react-select";
import CreatetableSelect from "react-select/creatable";
import { getReactSelectThemeProps } from "../../../helpers/reactSelectThemeStyles";
import "../CustomSelect/CustomSelect.scss";

const reactSelectThemeProps = getReactSelectThemeProps();

const CustomInputSelect = ({
  isCreatable,
  options,
  name,
  initValue,
  label,
  placeholder,
  disabled,
  onChange,
}) => {
  const [selectedOption, setSelectedOption] = useState(null);

  const handleSelectChange = (option) => {
    setSelectedOption(option);
    onChange(name, option);
  };

  useEffect(() => {
    if (initValue && initValue.value) {
      setSelectedOption(initValue);
    }
  }, [initValue]);

  return (
    <div className="custom-select-wrapper">
      <label className="custom-select-label">{label}</label>
      {isCreatable ? (
        <CreatetableSelect
          {...reactSelectThemeProps}
          options={options}
          value={selectedOption}
          isDisabled={disabled}
          placeholder={placeholder}
          onChange={handleSelectChange}
          formatCreateLabel={(inputValue) => `Aggiungi testo libero: "${inputValue}"`}
        />
      ) : (
        <Select
          {...reactSelectThemeProps}
          options={options}
          value={selectedOption}
          isDisabled={disabled}
          placeholder={placeholder}
          onChange={handleSelectChange}
        />
      )}
    </div>
  );
};

export default CustomInputSelect;
